import { render, staticRenderFns } from "./EnsTab.vue?vue&type=template&id=2ec970fe&"
import script from "./EnsTab.vue?vue&type=script&lang=js&"
export * from "./EnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports